import Vue from 'vue'
import VueRouter from 'vue-router'

const Login = () => import('../views/Login.vue')
const NotFound = () => import('../views/NotFound.vue')
const Test = () => import('../views/Test.vue')
const Home = () => import('../views/home/Home.vue')

//模块首页
const IndexLabel = () => import('../views/home/menu/label/IndexLabel.vue')
//设置
const Setup = () => import('../views/home/menu/label/setup/Setup.vue')
const Praise = () => import('../views/home/menu/label/setup/Praise.vue')
const Label = () => import('../views/home/menu/label/setup/Label.vue')
//评价
const Evaluate = () => import('../views/home/menu/label/evaluate/Evaluate.vue')

const Result = () => import('../views/home/menu/result/Result.vue')
const Shop = () => import('../views/home/menu/shop/Shop.vue')
const Exchange = () => import('../views/home/menu/shop/Exchange.vue')
const FindStudent = () => import('../views/home/menu/shop/FindStudent.vue')
Vue.use(VueRouter)

const routes = [
   { path: '/', redirect: '/login' },
  {
    path: '/login',
    component: Login
  },
  {
    path: '/notfound',
    component: NotFound
  },
  {
    path: '/test',
    component: Test
  },
  {
    path: '/home',
    component: Home,
    children: [
      // 标签
      { path: '/indexLabel', component: IndexLabel },
      {
        path: '/setup', component: Setup, children: [
          {
            path: 'praise', component: Praise, 
            // meta: {
            //   crumbList: [{ path: "/indexLabel", name: "标签", id: 1 },
            //   { path: "", name: "编辑表扬与提醒", id: 2 }]
            // }
          },
          {
            path: 'label', component: Label, 
            // meta: {
            //   crumbList: [{ path: "/indexLabel", name: "标签", id: 1 },
            //   { path: "", name: "编辑评价标签", id: 2 }]
            // }
          },
        ]
      },
      { path: '/evaluate', component: Evaluate },
      //成绩
      { path: '/result', component: Result },
      //充值
      { path: '/shop', component: Shop },
      //兑换
      {path:'/exchange',component:Exchange},
      //查找
      {path:'/findstudent',name:'/findstudent',component:FindStudent},
      


    ]
  }
]

const router = new VueRouter({
  routes
})

// to 到哪去
// from 从哪来
// next() 放行, next(路径) 拦截到对应的路由
// router.beforeEach((to, from, next) => {
//   if (to.matched.length === 0) {  //如果未匹配到路由
//     from.path ? next({ path: from.path }) : next('/notfound');   //如果上级也未匹配到路由则跳转主页面，如果上级能匹配到则转上级路由
//   } else {
//     next();    //如果匹配到正确跳转
//   }
// })

export default router
